module.exports = __webpack_public_path__ + "img/tuozahn.efe9384d.svg";